// ============================================================================
// SORU SATIŞI — paylaşılan küçük yardımcılar (2026-09-14).
// SatisEkleModal, SoruSatisi (Satış Arşivi), SatisArsivModal, SoruKarti ve
// App.js aynı tarih / rozet / kilit metnini kullansın diye tek yerde durur.
// Kullanıcı kararları: satış MÜNHASIR (satılmış soru tekrar satılamaz), iptal
// SİLMEZ (arşivde iz kalır), satılmış sorunun içeriği kilitli.
// ============================================================================

const pad = (n) => String(n).padStart(2, '0');

// 'YYYY-MM-DD' → 'GG.AA.YYYY'. Çıplak tarih Date nesnesine ÇEVRİLMEZ:
// '2026-09-12' UTC gece yarısı sayılır, yerel saatte bir gün kayabilirdi.
// Tam zaman damgası (ISO) gelirse yerel tarihe çevrilir.
export function trTarih(v) {
  const s = String(v == null ? '' : v).trim();
  if (!s) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

// ISO zaman damgası → 'GG.AA.YYYY SS:DD' (yerel saat). Geçersizse ''.
export function trZaman(v) {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Türkçe bulunma eki. Tarih okunurken son söylenen sayı YILdır:
// 2026 → "yirmi altı-da", 2025 → "yirmi beş-te", 2027 → "yirmi yedi-de".
const BIRLER_EK = ['', 'de', 'de', 'te', 'te', 'te', 'da', 'de', 'de', 'da'];
const ONLAR_EK = ['', 'da', 'de', 'da', 'ta', 'de', 'ta', 'te', 'de', 'da'];
export function sayiBulunmaEki(n) {
  const x = Math.abs(Math.trunc(Number(n) || 0));
  if (x === 0) return 'da';
  if (x % 10) return BIRLER_EK[x % 10];
  if (x % 100) return ONLAR_EK[Math.trunc(x / 10) % 10];
  return 'de'; // yüz / bin
}

// "12.09.2026'da" — tarih yoksa ''.
export function tarihteMetni(v) {
  const t = trTarih(v);
  return t ? `${t}'${sayiBulunmaEki(t.slice(-4))}` : '';
}

// Fiyat → "1.250 ₺" (panelin mevcut biçimi). null/boş → ''.
export function tlMetni(v) {
  if (v == null || v === '') return '';
  const n = Number(v);
  if (!Number.isFinite(n)) return '';
  return `${n.toLocaleString('tr-TR', { maximumFractionDigits: 2 })} ₺`;
}

// "#12, #45, #88 (+5)" — uzun listeler kısaltılır.
export function noListesi(nolar, enCok = 20) {
  const dizi = Array.isArray(nolar) ? nolar : [];
  const bas = dizi.slice(0, enCok).map((n) => `#${n}`).join(', ');
  return dizi.length > enCok ? `${bas} (+${dizi.length - enCok})` : bas;
}

// Başarılı POST /api/satis yanıtının tek satırlık özeti (modal + bildirimler).
export function satisOzeti(d) {
  const say = (x) => (Array.isArray(x) ? x.length : 0);
  const p = [];
  if (say(d && d.eklenen)) p.push(`${say(d.eklenen)} soru satışa eklendi`);
  if (say(d && d.fiyatlanan)) p.push(`${say(d.fiyatlanan)} teslim fiyatlandırıldı`);
  if (say(d && d.grup_eklenen)) p.push(`${say(d.grup_eklenen)} bağlam kardeşi eklendi`);
  return p.length ? p.join(' · ') : 'Satış kaydedildi';
}

// Soru satırındaki `satis` alanı: null | {satildi:true, yayinevi?, satis_tarihi?, fiyatli?}.
// yayinevi/tarih yalnız admin'e gelir — yoksa genel metin basılır.
export const satildiMi = (satis) => !!(satis && satis.satildi !== false);

export function satisRozetMetni(satis) {
  if (!satildiMi(satis)) return '';
  return satis.yayinevi ? `💰 ${satis.yayinevi}` : '💰 Satıldı';
}

export function satisRozetBaslik(satis) {
  if (!satildiMi(satis)) return '';
  const p = [satis.yayinevi ? `${satis.yayinevi} yayınevine satıldı` : 'Yayınevine satıldı'];
  const t = trTarih(satis.satis_tarihi);
  if (t) p.push(t);
  if (satis.fiyatli === false) p.push('fiyat bekliyor (PDF teslimi)');
  p.push('içerik kilitli');
  return p.join(' · ');
}

// 409 `satilmis_soru_kilitli` yanıtından onay sorusu.
export function satisKilitSorusu(d) {
  const s = (d && d.satis) || {};
  const no = d && d.public_no != null ? ` (#${d.public_no})` : '';
  const kime = s.yayinevi ? `${s.yayinevi} yayınevine` : 'bir yayınevine';
  const ne = tarihteMetni(s.satis_tarihi);
  return `Bu soru${no} ${kime}${ne ? ` ${ne}` : ''} satıldı; içerik kilitli. Yine de değiştirilsin mi?`;
}

// ---------------------------------------------------------------------------
// SATIŞ / BASIM UYGUNLUĞU (2026-09-14, kullanıcı: "Satış için seçilecek sorular
// onaylanmış olmalıdır"). Backend POST /api/satis aynı koşulları zorunlu tutar
// (409 satis_reddedildi); burada yalnız istemcide ÖNCEDEN gösterilir ki
// uygun olmayan soru modala hiç girmesin.
// ---------------------------------------------------------------------------
const DURUM_ETIKET = {
  onaylandi: 'onaylı',
  onay_bekliyor: 'onay bekliyor',
  reddedildi: 'reddedildi',
  uretildi: 'üretildi',
};

// Durum ENUM'u → okunur Türkçe ('onay_bekliyor' → 'onay bekliyor').
export function durumMetni(durum) {
  const d = String(durum == null ? '' : durum).trim();
  if (!d) return 'bilinmiyor';
  return DURUM_ETIKET[d] || d.replace(/_/g, ' ');
}

const puanBirMi = (v) => v != null && v !== '' && Number(v) === 1;

// Uygunsa null, değilse kısa Türkçe neden. Satırda bulunmayan alanın kuralı
// atlanır (ana liste satırı `kaynak`/`ogretmen_puani` taşımayabilir) — tek
// istisna `durum`: onay koşulu doğrulanamıyorsa soru uygun SAYILMAZ.
export function satisaUygunluk(soru) {
  if (!soru || typeof soru !== 'object') return 'Soru bulunamadı';
  if (soru.durum == null || soru.durum === '') return 'Onay durumu bilinmiyor';
  if (soru.durum !== 'onaylandi') return `Onaylı değil — durum: ${durumMetni(soru.durum)}`;
  if (soru.kaynak === 'osym_capa') return 'ÖSYM çapa sorusu';
  if (puanBirMi(soru.zorluk_puan) || puanBirMi(soru.ogretmen_puani)) return '1 puanlı (hatalı işaretli)';
  if (satildiMi(soru.satis)) {
    const p = [soru.satis.yayinevi, trTarih(soru.satis.satis_tarihi)].filter(Boolean);
    return p.length ? `Zaten satıldı (${p.join(' · ')})` : 'Zaten satıldı';
  }
  return null;
}

// Toplu seçim → satış (2026-09-14, kullanıcı: "13 soru seçili ama 1 soru için fiyat
// hesaplıyor"). Ana listede seçim sayfa/filtre değişince KORUNUR; eskiden yalnız
// ekrandaki sayfa süzülüyor, öteki seçimler SESSİZCE düşüyor, uygunsuzlar birkaç
// saniyelik bir bildirimle eleniyordu. Seçilen HER id için karar üretir: uygun
// public_no'lar + nedenli elenenler. Satırı gelmeyen id (silinmiş / yetkisiz)
// "Soru bulunamadı" olur — hiçbir seçim kayıtsız kaybolmaz.
export function secimiSatisIcinAyir(satirlar, istenenIds) {
  const harita = new Map((Array.isArray(satirlar) ? satirlar : []).filter(Boolean).map((s) => [s.id, s]));
  const ids = Array.isArray(istenenIds) ? istenenIds : [...harita.keys()];
  const uygun = [];
  const elenen = [];
  ids.forEach((id) => {
    const s = harita.get(id);
    if (!s) { elenen.push({ public_no: null, neden: 'Soru bulunamadı' }); return; }
    if (s.public_no == null) { elenen.push({ public_no: null, neden: 'Soru numarası yok' }); return; }
    const neden = satisaUygunluk(s);
    if (neden === null) uygun.push(Number(s.public_no));
    else elenen.push({ public_no: Number(s.public_no), neden });
  });
  return { uygun: [...new Set(uygun)], elenen };
}

// Elenenleri nedene göre toplar (ilk görülme sırası): [{ neden, nolar, sayi }].
// Numarasız kayıt (bulunamadı) sayıya girer, numara listesine girmez.
export function elenenleriGrupla(elenen) {
  const gruplar = new Map();
  (Array.isArray(elenen) ? elenen : []).forEach((e) => {
    const neden = (e && e.neden) || 'Satışa uygun değil';
    if (!gruplar.has(neden)) gruplar.set(neden, { neden, nolar: [], sayi: 0 });
    const g = gruplar.get(neden);
    g.sayi += 1;
    if (e && e.public_no != null) g.nolar.push(e.public_no);
  });
  return [...gruplar.values()];
}

// Basım yalnız onaylı soruyla; satılmış soru da basılır (yayınevine basım içindir).
export const basimaUygun = (soru) => !!soru && soru.durum === 'onaylandi';

// ---------------------------------------------------------------------------
// CEVAP QC (2026-09-15, KAPI C — plan "soru kalite kontrol aşaması"): satış ve basım
// öncesi son bakış. Kör denetçi (CEVAP-QC) ya da öğretmenin kör onayı (OGRETMEN-KOR)
// anahtarla uyuşmadıysa soru UYARILIR — ELENMEZ (engelleme kullanıcı kararı; Y1).
// Denetlenmemiş soru uyarı DEĞİL, kapsama bilgisidir: korpusun büyük kısmı henüz
// denetlenmedi, her seçimde kırmızı şerit gürültü olurdu.
// Değerler backend `services/cevapQc.js` QC_UYUSMAZLIK / QC_ONAY ile aynıdır.
// ---------------------------------------------------------------------------
const QC_UYUSMAZLIK = new Set(['DUZELTME', 'RED', 'KOD-KOSMADI',
  'SATILMIS-RAPOR:DUZELTME', 'SATILMIS-RAPOR:RED', 'SATILMIS-RAPOR:KOD-KOSMADI']);
const QC_ONAY = new Set(['ONAY', 'SATILMIS-RAPOR:ONAY']);

// Kör uyuşmazlık, kör cevaptan SONRA gelen Cevap QC ONAY'ıyla KAPANIR (2026-09-15, kullanıcı
// onayı): bağımsız kanıt anahtarı doğruladı, yanılan kör cevaptı. ÖNCEKİ bir QC onayı kapatmaz
// (kör cevap onunla çelişiyor — insan bakar); tarih okunamazsa kapanmaz (güvenli taraf).
// Backend `services/cevapQc.js` korUyusmazlikKapali ile AYNI kural.
const _zaman = (t) => (t == null || t === '' ? NaN : new Date(t).getTime());
export function korUyusmazlikKapali(soru) {
  const k = soru && soru.kor_onay;
  const q = soru && soru.cevap_qc;
  if (!k || !k.cevap || k.uyustu !== false) return false;
  if (!q || !QC_ONAY.has(q.sonuc)) return false;
  return _zaman(q.tarih) > _zaman(k.tarih);
}

// 'uyusmazlik' | 'onayli' | 'yok' — öğretmenin kör cevabı uyuşmadıysa (ve sonradan QC
// onayıyla kapanmadıysa) QC onayı da ezilir.
export function cevapQcDurumu(soru) {
  if (!soru || typeof soru !== 'object') return 'yok';
  if (soru.kor_onay && soru.kor_onay.cevap && soru.kor_onay.uyustu === false
      && !korUyusmazlikKapali(soru)) return 'uyusmazlik';
  const s = soru.cevap_qc && soru.cevap_qc.sonuc;
  if (QC_UYUSMAZLIK.has(s)) return 'uyusmazlik';
  if (QC_ONAY.has(s)) return 'onayli';
  return 'yok';
}

// Satırlardan QC özeti: { onayli, yok, uyusmazlik: [public_no...] }. `nolar` verilirse
// yalnız o numaralar sayılır (satış modalının "uygun" listesi gibi).
export function cevapQcOzeti(satirlar, nolar = null) {
  const kume = nolar ? new Set(nolar.map(Number)) : null;
  const ozet = { onayli: 0, yok: 0, uyusmazlik: [] };
  (Array.isArray(satirlar) ? satirlar : []).forEach((s) => {
    if (!s || (kume && !kume.has(Number(s.public_no)))) return;
    const d = cevapQcDurumu(s);
    if (d === 'uyusmazlik') ozet.uyusmazlik.push(Number(s.public_no));
    else ozet[d] += 1;
  });
  return ozet;
}

// ---------------------------------------------------------------------------
// SEÇİMDEN YAYINEVİ ÇÖZÜMÜ (2026-09-15, kullanıcı kararı "yeniden sorma"):
// Satış Arşivi'nden Basım'a giderken seçili satırların yayınevi Basım'a ön-seçili
// taşınır; fiyatlandırma modalı da aynı yoldan varsayılanı alır. Satırlar soru
// satırı ({satis:{satildi, yayinevi_id, yayinevi}}) ya da arşiv satırı
// ({yayinevi_id, yayinevi}) olabilir. Satılmamış satır (satis yok / satildi:false /
// yayinevi_id null) YOK SAYILIR. Birden fazla farklı yayınevi → karisik:true —
// çağıran basıma GİTMEZ (tek yayınevi kuralı); liste ilk görülme sırasıyla döner.
// ---------------------------------------------------------------------------
export function secimYayineviCoz(satirlar) {
  const gorulen = new Map();
  (Array.isArray(satirlar) ? satirlar : []).forEach((s) => {
    if (!s || typeof s !== 'object') return;
    let id = null;
    let ad = '';
    if (Object.prototype.hasOwnProperty.call(s, 'satis')) {
      // soru satırı: satış özeti `satis` altında (null / satildi:false → satılmamış)
      if (!satildiMi(s.satis)) return;
      id = s.satis.yayinevi_id;
      ad = s.satis.yayinevi;
    } else {
      // arşiv satırı: yayınevi doğrudan satırda
      id = s.yayinevi_id;
      ad = s.yayinevi;
    }
    if (id == null || id === '') return;
    const n = Number(id);
    if (!Number.isFinite(n)) return;
    if (!gorulen.has(n)) gorulen.set(n, { id: n, ad: String(ad == null ? '' : ad) });
  });
  const yayinevleri = [...gorulen.values()];
  if (yayinevleri.length === 0) return { yayineviId: null, yayineviAd: '', karisik: false, yayinevleri: [] };
  if (yayinevleri.length > 1) return { yayineviId: null, yayineviAd: '', karisik: true, yayinevleri };
  return { yayineviId: yayinevleri[0].id, yayineviAd: yayinevleri[0].ad, karisik: false, yayinevleri };
}

// POST /api/sorular/batch {public_nolar} en çok bu kadar numara kabul eder.
export const SORU_NO_TAVANI = 500;

// "12, #45 88" → { nolar: [12, 45, 88], gecersiz: [] }. Virgül / noktalı virgül /
// boşluk ayırır, baştaki # atılır, tekrarlar tekilleşir (ilk sıra korunur).
// Sayı olmayan parça ("12-15", "abc", "0") sessizce yutulmaz → `gecersiz`.
export function soruNoAyristir(metin) {
  const nolar = [];
  const gecersiz = [];
  const gorulen = new Set();
  String(metin == null ? '' : metin).split(/[,;\s]+/).forEach((parca) => {
    const t = parca.trim();
    if (!t) return;
    const m = /^#?(\d+)$/.exec(t);
    const n = m ? Number(m[1]) : NaN;
    if (!Number.isSafeInteger(n) || n <= 0) { gecersiz.push(t); return; }
    if (!gorulen.has(n)) { gorulen.add(n); nolar.push(n); }
  });
  return { nolar, gecersiz };
}
